const nme = {
    tooltip: 'TEAM',
    background: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/nme%2Fstaff_background.png?alt=media&token=cf99eed2-f1bc-4d4d-8ea0-f32acc1562f3',
    blurb: '...a team continuously seeking to introduce new and innovative solutions to the development and construction of architecture, and interior design in the region.',
    email: 'info@nme.company',
    subscribe: {
        background: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/nme%2Fcontact_background.png?alt=media&token=7c19faee-7a59-4991-b0c2-0568d61088cf',
        link: 'http://nme-me.us15.list-manage1.com/subscribe?u=2cfb7e5d672da18ba3398d036&id=d96a9a637a',
    },
    address: {
        KUWAIT: {
            floor: '2nd Floor',
            address: 'Jassim Al-Asfoor Tower',
            street: 'Al-Soor Street',
            postal: '33361 Rawda',
            country: 'Kuwait',
            tel: 'Tel: +965 1820 099 Ext: 800',
            fax: 'Fax: +965 2249 6201',
            mobile: 'Mob: +965 5509 9999',
            map: 'https://goo.gl/maps/nQwCJYvXtEF2',
        },
        DUBAI: {
            floor: '17th Floor',
            address: 'Latifa Tower',
            street: 'Sheikh Zayed Road',
            postal: '500 3527 Dubai',
            country: 'UAE',
            tel: 'Tel: +971 04446 8464',
            mobile: 'Mob: +971 50128 2069',
            map: 'https://goo.gl/maps/XEbXuq2YAtA2',
        },
        QATAR: {
            country: 'Qatar',
            mobile: 'Mob: +974 5022 4262',
        },
        GCC: {
            country: 'GCC & Middle East',
            tel: 'Tel: +965 55099999',
        },
    }
};

export default nme;



// WEBPACK FOOTER //
// ./src/data/nme.js